import { makeStyles } from '@material-ui/core';
import { MaterialPalette } from '@nutrien/cxp-components';

const useStyles = makeStyles({
  root: {
    height: 'calc(100vh - 162px)',
    overflowY: 'auto',

    '& ::-webkit-scrollbar': {
      overflow: 'auto',
      width: '8px',
    },

    '& ::-webkit-scrollbar-thumb': {
      background: '#383838',
      borderRadius: '10px',
    },
  },
  card: {
    padding: '16px',
    borderRadius: 0,
  },
  scrollHide: {
    '& ::-webkit-scrollbar': {
      display: 'none',
    },
    overflow: 'hidden',
  },

  assetProperties: {
    padding: '0px 16px 16px 23px',
    display: 'flex',
    flexDirection: 'row',
    borderRadius: '0px',
    flexBasis: '0%',
  },
  blockShape: {
    minWidth: 32,
    height: 32,
    backgroundColor: '#6d6d6d',
    color: MaterialPalette.common.white,
    fontSize: 20.8,
    position: 'relative',
  },
  textStyles: {
    textAlign: 'center',
    margin: '0 auto 0',
    color: 'black',
  },
  gridLinesLayout: {
    position: 'absolute',
    left: 130,
    top: 60,
    zIndex: 1,
  },
  upperLowerBlock: {
    position: 'absolute',
    left: 85,
    top: 70,
    zIndex: 1,
  },
  areaPropertiesMainGrid: {
    padding: '0px 16px 0px 8px',
    backgroundClip: 'content-box',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    overflowY: 'auto',
    height: '100%',
  },
  areaPropertiesChildGrid: {
    maxWidth: '100%',
    flexBasis: 'auto',
    flexFlow: 'column',
  },
  westEastBlock: {
    display: 'inline-block',
    marginRight: 8,
    height: 0,
  },
  northSouthBlock: {
    display: 'flex',
    height: 44,
    marginRight: 0,
  },
  northSouthblockHeight: {
    lineHeight: 0,
    paddingRight: 16,
  },
  westEastBlockHeight: {
    lineHeight: 0,
    paddingRight: 0,
  },
  shaftUpperLowerBlock: {
    position: 'absolute',
    left: '-5px',
    top: '60px',
    zIndex: 1,
  },
  graphMainElevation: {
    display: 'flex',
    marginTop: 48,
  },
  subAreaMainElevation: {
    marginLeft: 108,
  },
  subAreaElevation: {
    display: 'flex',
  },
  subAreaElevation2: {
    height: 100,
    borderTop: '1px solid #6d6d6d',
    borderBottom: '1px solid #6d6d6d',
    width: 30,
  },
  left: {
    borderRight: '1px solid #6d6d6d',
  },
  right: {
    borderLeft: '1px solid #6d6d6d',
  },
  middle: {
    height: 28,
    marginTop: 35,
  },
  subareaLineElevation: {
    margin: 'auto',
    width: 60,
    height: 28,
    border: '1px solid #6d6d6d',
    borderTop: '1.5px solid #6d6d6d',
    borderBottom: '1.5px solid #6d6d6d',
    color: '#707070',
    position: 'relative',
    display: 'inline-block',
  },
  elevationP: {
    position: 'absolute',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontSize: 12,
    color: MaterialPalette.text.primary,
  },
  gridLineTag: {
    position: 'relative',
    left: 97,
  },
  loadingOrError: {
    margin: '16px 0px 16px 0px',
    display: 'flex',
    flexDirection: 'row',
  },
  innerBlock: {
    display: 'flex',
    flexDirection: 'row',
  },
  riskAssessmentGrid: {
    '& .headingText': {
      fontStyle: 'normal',
      margin: '0px 0px 16px 23px',
      color: 'rgba(255, 255, 255,0.8)',
      fontWeight: 600,
    },
  },
  gridBlock: {
    height: 8,
  },
  mainGrid: {
    display: 'flex',
    flexDirection: 'row',
  },
  treeviewGrid: {
    display: 'block',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
  },
  title: {
    padding: '16px 0px 19px 23.5px',
  },
  properties: {
    flexDirection: 'column',
    maxWidth: '100%',
  },
  layout: {
    display: 'flex',
    minWidth: 144,
  },
  northSouth: {
    position: 'absolute',
    left: 23.5,
    top: 135,
    zIndex: 1,
  },
  subArea: {
    position: 'absolute',
    top: 103,
    left: 109.5,
  },
  subAreaGrid: {
    width: 48,
    height: 48,
    border: '1px solid #707070',
    color: '#707070',
  },
  linePosition: {
    position: 'relative',
    display: 'inline-block',
  },
  areaType: {
    color: MaterialPalette.text.primary,
    margin: 'auto',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontSize: 14,
  },
  error: {
    position: 'absolute',
    top: '220px',
    left: '112px',
  },
  risk: {
    flexDirection: 'column',
    maxWidth: '100%',
  },
  riskText: {
    padding: '20px 0px 19px 23.5px',
  },
  topPadding: {
    paddingTop: 0,
  },
  gridlines: {
    display: 'flex',
    position: 'relative',
    height: (props: { size: { width: number; height: number } }) =>
      props?.size?.height > props?.size?.width ? '25%' : '40%',
  },
  gridlinesElevation: {
    width: 'auto',
    left: 23,
  },
});

export default useStyles;
